// Centralized data-testids
export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const NAV = {
  logo: 'nav-logo',
  plans: 'nav-plans',
  about: 'nav-about',
  process: 'nav-process',
  faq: 'nav-faq',
  contact: 'nav-contact',
  ctaQuote: 'nav-cta-quote',
  mobileToggle: 'nav-mobile-toggle',
};

export const HERO = {
  section: 'hero-section',
  primaryCta: 'hero-primary-cta',
  secondaryCta: 'hero-secondary-cta',
};

export const PLANS = {
  section: 'plans-section',
  card: (slug) => `plan-card-${slug}`,
  selectBtn: (slug) => `plan-select-${slug}`,
};

export const PROCESS = {
  section: 'process-section',
};

export const TESTIMONIALS = {
  section: 'testimonials-section',
};

export const FAQ = {
  section: 'faq-section',
  item: (i) => `faq-item-${i}`,
};

export const LEAD = {
  section: 'lead-section',
  form: 'lead-form',
  name: 'lead-name',
  email: 'lead-email',
  phone: 'lead-phone',
  age: 'lead-age',
  coverage: 'lead-coverage',
  tobacco: 'lead-tobacco',
  plan: 'lead-plan',
  message: 'lead-message',
  submit: 'lead-submit',
  success: 'lead-success',
};

export const CHAT = {
  fab: 'chat-fab',
  panel: 'chat-panel',
  close: 'chat-close',
  input: 'chat-input',
  send: 'chat-send',
  messages: 'chat-messages',
  message: (i) => `chat-msg-${i}`,
};

export const FOOTER = {
  root: 'site-footer',
};
